import { useEffect, useState } from 'react';
import classes from './ChatStateMachine.module.css'

import SystemMessage from './SystemMessage';
import SystemSuggestions from './SystemSuggestions';
import Discovery from './Discovery';
import { stateMachineTrigerred } from '../../../../../store/chatAi-actions';
import { useDispatch, useSelector } from 'react-redux';
import UserResponse from './UserResponse';
import useLevels from '../../../../../hooks/useLevelsBar';
import { useNavigate } from "react-router-dom";
import { getUserAllSchoolProperty } from '../../../../../utils/utils';

function ChatStateMachine(props) {

    const disptach = useDispatch()
    const chatState = useSelector(state => state.chat)
    const authState = useSelector(state => state.auth)
    const levels = useLevels();
    const navigate = useNavigate();
    const { texts } = useSelector(state => state.translate);


    useEffect(() => {
        if (!authState?.userDetails) return
        if (chatState.stateMachine.current == null) {
            disptach(stateMachineTrigerred("welcome-message"))
        } else {
            let state = stateMachine[chatState.stateMachine.current]
            if (state && state.next) {
                state.next()
            }
        }
    }, [authState, chatState.stateMachine])

    let greeting = texts.greeting
    let supervisionId = getUserAllSchoolProperty(authState.userDetails, "supervisionId") || [1]
    let isHemed = supervisionId[0] == 2
    if (isHemed) {
        greeting = texts.greetingMamad
    }

    console.log(chatState.stateMachine.current)
    let disableSuggestions = props.disabled || (chatState.stateMachine.current === "discovery")
    
    const stateMachine = {
        "welcome-message": {
            type: <SystemMessage key={0} text={greeting} />,
            next: () => {
                if (isHemed) {
                    nextState("back-to-camp-suggestion")
                } else {
                    nextState("stay-here-response")                
                }
            },
            level: 0
        },
        // "back-to-camp-message-1": {
        //     type: <SystemMessage key={1} text = {texts.campText}/>,
        //     next: () => nextState("back-to-camp-message-2"),
        //     level: 1
        // },
        // "back-to-camp-message-2": {
        //     type: <SystemMessage key={2} text={texts.campQuestion} />,
        //     next: () => nextState("back-to-camp-suggestion"),
        //     level: 2
        // },
        "back-to-camp-suggestion": {
            type: <SystemSuggestions disabled={disableSuggestions} key={3} options={[
                { text: texts.goToCamp, handler: () => { navigate("/curatorship?tab=videos") } },
                {
                    text: texts.IWillStay, handler: () => { nextState("stay-here") }
                }]} />,
            next: () => { },
            level: 3
        },
        "stay-here": {
            type: <UserResponse key={4} text={texts.IWillStay} />,
            next: () => { nextState("stay-here-response") },
            level: 4
        },
        "stay-here-response": {
            type: <SystemMessage key={5} text={texts.happyUStay} />,
            next: () => { nextState("discovery") },
            level: 5
        },
        "discovery": {
            state: "discovery",
            type: <Discovery key={6} />,
            next: null,
            level: 6
        }
    }

    const nextState = (next) => {
        const curr = stateMachine[chatState.stateMachine.current]
        const nextState = stateMachine[next]
        if (nextState.level > curr.level) {
            disptach(stateMachineTrigerred(next))
        }
    }

    return (
        <div className={classes.ChatStateMachine}>
            {chatState.stateMachine.states.map(s => {
                let state = stateMachine[s]
                let Component = (state.type)
                return Component
            })}
        </div>
    );
}

export default ChatStateMachine;
